module.exports = __webpack_public_path__ + "img/16.1.6137bd33.jpg";